export default "__VITE_ASSET__ClDWI$8U__"